import React, { Component } from 'react'
import Cookies from 'universal-cookie'
import Auth from '../login/auth/auth'

import EmptyLayout from '../../_layouts/empty-layout'

import HeadingComponent from '../../components/heading/heading.component'
import LabelComponent from '../../components/label/label.component'
import InputComponent from '../../components/input/input.component'
import CheckboxComponent from '../../components/checkbox/checkbox.component'
import LinkComponent from '../../components/link/link.component'

import { BackgroundContainer, LoginContainer, SideContainer, LogoContainer, LoginFormContainer, RememberContainer, CopyContainer, ErrorContainer } from './login.styles'

const cookies = new Cookies()

class LoginIndex extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: '',
      password: '',
      errorMessage: '',
      remember: false
    }
    this.date = new Date()
  }

  componentDidMount() {
    if(cookies.get('admin_token')){
      Auth.login(() => {
        this.props.history.push('/dashboard')
      });
    } else {
      this.props.history.push('/');
    }
  }

  handleChangeInput = e => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleSubmit = e => {
    e.preventDefault();
    fetch(process.env.REACT_APP_API_URL + '/authenticate/teacher', {
      method: 'POST',
      body: JSON.stringify({
        username: this.state.username,
        password: this.state.password
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json()).then(res => {
      if(res.auth_token) {
        if(process.env.NODE_ENV === 'development') {
          cookies.remove('admin_token',{ path: '/' })
          cookies.set('admin_token', res.auth_token, { path: '/'})
        }else {
          cookies.remove('admin_token',{ path: '/' })
          cookies.set('admin_token', res.auth_token, { path: '/'})
        }
      
        Auth.login(() => {
          this.props.history.push('/dashboard')
        });
      } else {
        this.setState({ errorMessage: res.error.user_authentication })
      }
    })
  }

  handleChangeCheckbox = e => {
    this.setState({ remember: e.target.checked })
  }

  render() {
    return (
      <EmptyLayout>
        <BackgroundContainer>
          <LoginContainer>
            <SideContainer>
              <LogoContainer></LogoContainer>
            </SideContainer>
            <LoginFormContainer onSubmit={this.handleSubmit}>
              <HeadingComponent type="h1">
                Login
              </HeadingComponent>
                <ErrorContainer>{this.state.errorMessage}</ErrorContainer> 
              <LabelComponent mode="block">
                Username
              </LabelComponent>
              <InputComponent id='input-username' type="username" mode="large" name="username" value={this.state.username} onChange={this.handleChangeInput} required/>
              <LabelComponent mode="block">
                Password
              </LabelComponent>
              <InputComponent id='input-password' type="password" mode="large" name="password" value={this.state.password} onChange={this.handleChangeInput} required/>
              <RememberContainer>
                <CheckboxComponent id='check-remember' name="remember" mode="form" handleChange={this.handleChangeCheckbox}>Remember</CheckboxComponent>
                <LinkComponent id='link-forgot' mode='clearlink' to='/'>Forgot?</LinkComponent>
              </RememberContainer>
              <InputComponent id='button-login' type="submit" mode="large" value="Login"/>
            </LoginFormContainer>
            <CopyContainer>
              © {this.date.getFullYear()} GENIO. All Rights Reserved.
              <LinkComponent mode='clearlink' to='mailto:sales@edu.com'>Contact Us</LinkComponent>
            </CopyContainer>
          </LoginContainer>
        </BackgroundContainer>
      </EmptyLayout>
    )
  }
}

export default LoginIndex;